import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["blocks", "extra", "data"],
  _excluded2 = ["name"],
  _excluded3 = ["name"],
  _excluded4 = ["children", "className"];
import { cloneElement, forwardRef, isValidElement, useState } from 'react';
import { Render, Provider, Container, useStore } from 'react-login-page';
import { Username } from './control/login/Username';
import { Password } from './control/login/Password';
import { Submit } from './control/login/Submit';
import { Footer } from './control/Footer';
import { Logo } from './control/Logo';
import { Title } from './control/Title';
import { TitleLogin } from './control/TitleLogin';
import { TitleSignup } from './control/TitleSignup';
import './index.css';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export * from 'react-login-page';
export * from './control/login/Username';
export * from './control/login/Password';
export * from './control/login/Submit';
export * from './control/Title';
export * from './control/TitleLogin';
export * from './control/TitleSignup';
export * from './control/Logo';
export * from './control/Footer';
var RenderLogin = () => {
  var _useStore = useStore(),
    {
      blocks = {},
      extra = {},
      data
    } = _useStore,
    label = _objectWithoutPropertiesLoose(_useStore, _excluded);
  var {
    fields,
    buttons
  } = data || {
    fields: []
  };
  var [panel, setPanel] = useState('login');
  var loginButtons = buttons.filter(m => m.name.indexOf("$$login") > -1).sort((a, b) => a.index - b.index);
  var loginFields = fields.filter(m => m.name.indexOf("$$login") > -1).sort((a, b) => a.index - b.index);
  var signupButtons = buttons.filter(m => m.name.indexOf("$$signup") > -1).sort((a, b) => a.index - b.index);
  var signupFields = fields.filter(m => m.name.indexOf("$$signup") > -1).sort((a, b) => a.index - b.index);
  return /*#__PURE__*/_jsx(Render, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "login-page8-inner",
      children: [/*#__PURE__*/_jsxs("header", {
        children: [blocks.logo, blocks.title]
      }), /*#__PURE__*/_jsxs("main", {
        children: [/*#__PURE__*/_jsxs("article", {
          className: panel === 'login' ? 'active' : '',
          children: [/*#__PURE__*/_jsx("button", {
            onClick: () => setPanel('login'),
            children: blocks['title-login']
          }), /*#__PURE__*/_jsxs("section", {
            className: "login-page8-fields login-page8-login",
            children: [loginFields.map((item, idx) => {
              var extraLabel = extra[item.name];
              if (!item.children && !extraLabel) return null;
              if (!item.children && extraLabel) return /*#__PURE__*/_jsx("div", {
                children: extraLabel
              }, idx);
              if (!item.children) return null;
              var labelElement = label[item.name];
              var htmlFor = item.name.replace('$$login', '');
              var _item$children$props = item.children.props,
                {
                  name
                } = _item$children$props,
                props = _objectWithoutPropertiesLoose(_item$children$props, _excluded2);
              return /*#__PURE__*/_jsxs("label", {
                className: "rlp-" + item.name,
                htmlFor: htmlFor,
                children: [labelElement && /*#__PURE__*/_jsx("span", {
                  className: "login-page8-label",
                  children: labelElement
                }), /*#__PURE__*/cloneElement(item.children, _extends({}, props, {
                  name: panel === 'login' ? name : '',
                  key: item.name + idx
                })), extraLabel && /*#__PURE__*/_jsx("div", {
                  children: extraLabel
                })]
              }, item.name + idx);
            }), /*#__PURE__*/_jsx("section", {
              className: "login-page8-button",
              children: loginButtons.map((item, idx) => {
                var child = item.children;
                if (! /*#__PURE__*/isValidElement(child)) return null;
                return /*#__PURE__*/cloneElement(child, _extends({}, child.props, {
                  key: item.name + idx
                }));
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("article", {
          className: panel === 'signup' ? 'active' : '',
          children: [/*#__PURE__*/_jsx("button", {
            onClick: () => setPanel('signup'),
            children: blocks['title-signup']
          }), /*#__PURE__*/_jsxs("section", {
            className: "login-page8-fields login-page8-signup",
            children: [signupFields.map((item, idx) => {
              var extraLabel = extra[item.name];
              if (!item.children && !extraLabel) return null;
              if (!item.children && extraLabel) return /*#__PURE__*/_jsx("div", {
                children: extraLabel
              }, idx);
              if (!item.children) return null;
              var labelElement = label[item.name];
              var htmlFor = item.name.replace('$$signup', '');
              var _item$children$props2 = item.children.props,
                {
                  name
                } = _item$children$props2,
                props = _objectWithoutPropertiesLoose(_item$children$props2, _excluded3);
              return /*#__PURE__*/_jsxs("label", {
                htmlFor: htmlFor,
                children: [labelElement && /*#__PURE__*/_jsx("span", {
                  className: "login-page8-label",
                  children: labelElement
                }), /*#__PURE__*/cloneElement(item.children, _extends({}, props, {
                  name: panel === 'signup' ? name : '',
                  key: item.name + idx
                })), extraLabel && /*#__PURE__*/_jsx("div", {
                  children: extraLabel
                })]
              }, item.name + idx);
            }), /*#__PURE__*/_jsx("section", {
              className: "login-page8-button",
              children: signupButtons.map((item, idx) => {
                var child = item.children;
                if (! /*#__PURE__*/isValidElement(child)) return null;
                return /*#__PURE__*/cloneElement(child, _extends({}, child.props, {
                  key: item.name + idx
                }));
              })
            })]
          })]
        })]
      }), blocks.footer]
    })
  });
};
var LoginPage = /*#__PURE__*/forwardRef((props, ref) => {
  var {
      children,
      className
    } = props,
    divProps = _objectWithoutPropertiesLoose(props, _excluded4);
  return /*#__PURE__*/_jsxs(Provider, {
    children: [/*#__PURE__*/_jsx(Title, {}), /*#__PURE__*/_jsx(TitleSignup, {}), /*#__PURE__*/_jsx(TitleLogin, {}), /*#__PURE__*/_jsx(Logo, {}), /*#__PURE__*/_jsx(Username, {}), /*#__PURE__*/_jsx(Password, {}), /*#__PURE__*/_jsx(Submit, {}), /*#__PURE__*/_jsx(Username, {
      panel: "signup",
      label: "E-mail",
      type: "email",
      placeholder: "E-mail",
      keyname: "e-mail"
    }), /*#__PURE__*/_jsx(Password, {
      panel: "signup",
      label: "Password",
      placeholder: "Password",
      keyname: "password"
    }), /*#__PURE__*/_jsx(Password, {
      panel: "signup",
      label: "Confirm Password",
      placeholder: "Confirm Password",
      keyname: "confirm-password"
    }), /*#__PURE__*/_jsx(Submit, {
      keyname: "signup-submit",
      panel: "signup",
      children: "Signup"
    }), /*#__PURE__*/_jsxs(Container, _extends({}, divProps, {
      className: "login-page8 " + (className || ''),
      children: [/*#__PURE__*/_jsx(RenderLogin, {}), children]
    }))]
  });
});
var Login = LoginPage;
Login.Username = Username;
Login.Password = Password;
Login.Submit = Submit;
Login.Footer = Footer;
Login.Logo = Logo;
Login.Title = Title;
Login.TitleLogin = TitleLogin;
Login.TitleSignup = TitleSignup;
Login.displayName = 'BaseLoginPage';
export default Login;